export function formatDate(dateLike, fallback = '-') {
  if (dateLike === null || dateLike === undefined || dateLike === '') return fallback;

  // Accept Date
  if (dateLike instanceof Date) {
    // Convert to ISO date
    const iso = dateLike.toISOString().slice(0, 10); // YYYY-MM-DD
    const [yyyy, mm, dd] = iso.split('-');
    return `${dd}/${mm}/${yyyy}`;
  }

  const raw = String(dateLike);

  // Already formatted
  if (/^\d{2}\/\d{2}\/\d{4}$/.test(raw)) return raw;
  if (/^\d{2}-\d{2}-\d{4}$/.test(raw)) return raw.replaceAll('-', '/');

  // ISO / MySQL-ish
  const iso = raw.length >= 10 ? raw.slice(0, 10) : raw;
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return raw;

  const [yyyy, mm, dd] = iso.split('-');
  return `${dd}/${mm}/${yyyy}`;
}

